const text = 'https://api.zhugecoming.com'
// const text = 'http://ob.zhugecoming.com'
const config = {
  ip:text+'/api',
  socket:text+':6002',
  imgUrl:text
}
export default config



// WEBPACK FOOTER //
// ./src/utils/httpConfig.js